import type { ReactNode } from "react";

import css from "../styles/Cell.module.css";

interface ApproxTextProps {
  text: string;
}

export const ApproxText = ({ text }: ApproxTextProps): ReactNode => {
  if (!text.startsWith("~")) return text;
  return (
    <>
      <span className={css.affix}>~</span>
      {text.slice(1)}
    </>
  );
};
